
import { motion } from 'framer-motion'
import logo from '../../../Assets/Images/logo.png'
import { useSelector } from "react-redux"
import RasiKattam from "../../../Components/RasiKattam"
import AmsaKattam from "../../../Components/AmsaKattam"


const tMaritalStatus = [{ text: 'திருமணம் செய்து கொள்ளவில்லை', value: 'Never Married' }, { text: 'விவாகரத்து பெற்றவர்', value: 'Divorced' }, { text: 'விதவை', value: 'Widow' }, { text: 'மனைவியை இழந்தவன்', value: 'Widower' },{text:"பிரிந்தனர்",value:'seperated'}]


const PrintUser = ({ userDetails }) => {

    const educationList = useSelector((state) => state.auth.educationList)
    const zodiacSigns = useSelector((state) => state.auth.zodiacSigns)
    const flaws = useSelector((state) => state.auth.flaws)
    const occupation = useSelector((state) => state.auth.fullOccupations)
    const allStars = useSelector((state) => state.auth.allStars)
    const status = useSelector((state) => state.auth.status)
    const tStatus = useSelector((state) => state.auth.tStatus)
    const tFlaws = useSelector((state) => state.auth.tFlaws)
    const tOccupation = useSelector((state) => state.auth.tOccupation)
    const dhisas = useSelector((state) => state.auth.tDhisa)

    const calculateAge = (birthdate) => {
        const today = new Date();
        const birthDate = new Date(birthdate);
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();

        // If birth month is after current month or same month but birth date is after current date, subtract 1
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        return age;
    };

    const getFlaws = (value) => {
        return tFlaws.filter((x) => x.value === value)[0].text
    }

    const getStatus = (value) => {
        return tStatus.filter((x) => x.value === value)[0].text
    }

    const getZodiac = (value) => {
        return zodiacSigns.filter((x) => { return x.value === value })[0].text
    }

    const getStars = (value) => {
        return allStars.filter((x) => { return x.value === value })[0]?.text || '--'
    }

    const getDhisas = (values) => {
        return values ? dhisas.filter((x) => { return x.value === parseInt(values) })[0].text : '-'
    }

    const clearHeights = (height) => {
        let input = height;
        let cleaned = input.match(/\d+\s*ft\s*\d*\s*in/);
        return cleaned ?  cleaned[0] : '--'
    }

    return (
        <motion.div className="border border-primeColor flex flex-col min-h-screen w-full relative">
            <motion.div className="flex flex-row justify-between px-10 py-1 w-full">
                <motion.div className="flex flex-col justify-between h-fit">
                    <motion.div className="flex flex-col">
                        <motion.div className="bg-primeColor justify-center w-full text-center items-center flex flex-row h-fit px-2 py-2">
                            <img src={logo} height={70} width={70} />
                        </motion.div>
                        <p className="w-full flex flex-row justify-center items-center py-2">Kallar thirumana sevai</p>
                    </motion.div>
                    <p className="text-2xl text-primeColor font-bold">www.royalkavery.com</p>
                </motion.div>

                <motion.div className="flex flex-col py-5">
                    <p>Royal kavery matrimony</p>
                    <p>Thanjavur</p>
                </motion.div>
            </motion.div>
            <motion.div className="h-1 w-full bg-primeColor" />
            <motion.div className='flex flex-row h-full w-full'>
                <motion.div className="flex flex-col gap-1 w-4/6 px-5 py-2">
                    <motion.div className="flex flex-row justify-between w-full">
                        <p className="font-bold text-sm w-2/4">பதிவு எண்</p>
                        <p className="text-sm w-2/4">- {userDetails?.refId}</p>
                    </motion.div>
                    <motion.div className="flex flex-row justify-between w-full">
                        <p className="font-bold w-2/4 text-sm">பெயர்</p>
                        <p className="justify-start w-2/4 text-sm">- {userDetails?.firstName}</p>
                    </motion.div>
                    <motion.div className="flex flex-row w-full justify-between">
                        <p className="font-bold w-2/4 text-sm">தந்தை பெயர்</p>
                        <p className="text-sm  w-2/4 flex flex-row">- {userDetails?.familyInformation?.fatherFirstName} / {userDetails?.familyInformation?.fatherSurname} / {userDetails?.familyInformation?.fatherNative}</p>
                    </motion.div>
                    <motion.div className="flex flex-row w-full justify-between">
                        <p className="font-bold w-2/4 text-sm">தாய் பெயர்</p>
                        <p className="text-sm flex w-2/4 flex-row">- {userDetails?.familyInformation?.motherFirstName} / {userDetails?.familyInformation?.motherSurname} / {userDetails?.familyInformation?.motherNative}</p>
                    </motion.div>
                    <motion.div className="flex flex-row w-full  justify-between">
                        <p className="font-bold w-2/4 text-sm">படிப்பு</p>
                        <p className="text-sm w-2/4 flex flex-row flex-wrap">-{userDetails?.otherEducationalQualification}</p>
                    </motion.div>
                    <motion.div className="flex flex-row w-full  justify-between">
                        <p className="font-bold w-2/4 text-sm">தொழில்</p>
                        <p className="text-sm w-2/4">- { userDetails ? userDetails.occupationDetail || userDetails.occupation : '---'}</p>
                    </motion.div>
                    <motion.div className="flex flex-row w-full  justify-between">
                        <p className="font-bold w-2/4 text-sm">வருமானம்</p>
                        <p className="text-sm w-2/4">- {userDetails?.salary ? userDetails?.salary + '/' + (userDetails?.salaryMode === 'year' ? 'ஆண்டு' : 'மாதம்') : '---'}</p>
                    </motion.div>
                    <motion.div className="flex flex-row w-full justify-between">
                        <p className="font-bold w-2/4 text-sm">வயது/உயரம்</p>
                        <p className="text-sm w-2/4">- {calculateAge(userDetails?.dateOfBirth) + ' / ' + clearHeights(userDetails?.heightInFeet)}</p>
                    </motion.div>
                    <motion.div className="flex flex-row w-full justify-between">
                        <p className="font-bold w-2/4 text-sm">உடன் பிறந்தவர்கள்</p>
                        <p className="text-sm flex flex-row w-2/4">- <p className='font-bold'>ஆண் &nbsp;{userDetails?.familyInformation?.numberOfMaleSiblings}</p>&nbsp;<p className='font-bold'>பெண் &nbsp;{userDetails?.familyInformation?.numberOfFemaleSiblings}</p></p>
                    </motion.div>
                    <motion.div className="flex flex-row w-full justify-between">
                        <p className="font-bold w-2/4 text-sm">தொடர்பு முகவரி</p>
                        {userDetails.contactInformation.presentAddress && userDetails.isDownloaded && <p className="text-sm flex flex-row w-2/4">- {userDetails.contactInformation?.presentAddress.addressLine1 + ',' + userDetails.contactInformation.presentAddress.addressLine2 + ',' + userDetails.contactInformation.presentAddress.city + ',' + userDetails.contactInformation.presentAddress.district + ',' + userDetails.contactInformation.presentAddress.state + ',' + userDetails.contactInformation.presentAddress.pinCode || '--'}</p> || <p className="text-sm flex flex-row w-2/4">--</p>}
                    </motion.div>
                    <motion.div className="flex flex-row w-full justify-between">
                        <p className="font-bold w-2/4 text-sm">அலைபேசி எண்</p>
                        <p className="text-sm flex flex-row w-2/4">-  {userDetails.isDownloaded  && userDetails.contactInformation?.mobileNumber || '--'}</p>
                    </motion.div>
                </motion.div>
                <motion.div className='flex flex-col justify-end w-2/6  py-2'>
                    <motion.div className='h-60 w-fit'>
                        {userDetails?.previewUrls && userDetails.previewUrls[0] && (
                        <img src={userDetails.previewUrls[0]?.imageUrl} className="h-60 w-60 object-contain" alt="Preview" />
                    )}
                    </motion.div>
                    <motion.div className="flex flex-row w-full justify-between">
                        <p className="font-bold w-2/4 text-sm">திருமண நிலை</p>
                        {<p className="text-sm flex flex-row w-2/4">- {tMaritalStatus.filter(x=>x.value === userDetails?.maritalStatus)[0].text || '--'}</p> }
                    </motion.div>
                    <motion.div className="flex flex-row w-full justify-between">
                        <p className="font-bold w-2/4 text-sm">சொத்து தகவல்</p>
                        <p className="text-sm flex flex-row w-2/4">-  {userDetails?.familyInformation?.assetInfo|| '--'}</p>
                    </motion.div>
                </motion.div>
            </motion.div>
            <motion.div className="w-full flex flex-col items-center justify-center">
                <p className="w-fit px-2 py-1 rounded-full text-sm ring ring-1 ring-black">ஜாதக விவரம்</p>
            <motion.div className="flex flex-wrap flex-row w-full px-5 py-2 gap-3 justify-center">
                <motion.div className="flex flex-row justify-start gap-2">
                    <p className="text-sm font-bold">தமிழ் வருடம்:</p>
                    <p className="text-sm">{userDetails?.tamilYear || '---'}</p>
                </motion.div>
                <motion.div className="flex flex-row justify-start gap-2">
                    <p className="text-sm font-bold">தமிழ் மாதம்:</p>
                    <p className="text-sm">{userDetails?.tamilMonth || '---'}</p>
                </motion.div>
                <motion.div className="flex flex-row justify-start gap-2">
                    <p className="text-sm font-bold">தமிழ் தேதி:</p>
                    <p className="text-sm">{userDetails?.tamilDate || '---'}</p>
                </motion.div>
                <motion.div className="flex flex-row justify-start gap-2">
                    <p className="text-sm font-bold">கிழமை:</p>
                    <p className="text-sm">{userDetails?.birthDay || '---'}</p>
                </motion.div>
                <motion.div className="flex flex-row justify-start gap-2">
                    <p className="text-sm font-bold">நட்சத்திரம்:</p>
                    <p className="text-sm flex flex-row">{userDetails?.additionalInformation?.star ? getStars(userDetails?.additionalInformation?.star) || '---' : '---'}<span>{userDetails?.additionalInformation?.padham || '---'}</span></p>
                </motion.div>
                <motion.div className="flex flex-row justify-start gap-2">
                    <p className="text-sm font-bold">இராசி:</p>
                    <p className="text-sm">{userDetails?.additionalInformation?.zodiacSign ? getZodiac(userDetails?.additionalInformation?.zodiacSign) || '---' : '----'}</p>
                </motion.div>
                <motion.div className="flex flex-row justify-start gap-2">
                    <p className="text-sm font-bold">பிறந்த ஊர்:</p>
                    <p className="text-sm">{userDetails?.birthPlace || '---'}</p>
                </motion.div>
                <motion.div className="flex flex-row justify-start gap-2">
                    <p className="text-sm font-bold">பிறந்த தேதி:</p>
                    <p className="text-sm">{userDetails?.dateOfBirth ? userDetails?.dateOfBirth?.split('-')[2] + '/' + userDetails?.dateOfBirth?.split('-')[1] + '/' + userDetails?.dateOfBirth.split('-')[0] : '---' || '---'}</p>
                </motion.div>
                <motion.div className="flex flex-row justify-start gap-2">
                    <p className="text-sm">{userDetails?.thisaiIruppu ? getDhisas(userDetails?.thisaiIruppu) || '---' : '---'}</p>
                    <p className="text-sm font-bold">திசை இருப்பு</p>
                </motion.div>
                <motion.div className="flex flex-row justify-start gap-2">
                    <p className="text-sm font-bold">வருடம்</p>
                    <p className="text-sm">{userDetails?.thisaiIruppuYear || '---'}</p>
                    <p className="text-sm font-bold">மாதம்</p>
                    <p className="text-sm">{userDetails?.thisaiIruppuMonth || '---'}</p>
                    <p className="text-sm font-bold">நாள்</p>
                    <p className="text-sm">{userDetails?.thisaiIruppuDate || '---'}</p>
                </motion.div>
            </motion.div>
            {<motion.div className="h-full flex flex-row min-w-screen py-2 justify-between px-5 gap-1 my-10">
                <RasiKattam kattamOuterInjectClass={`h-[300px] w-[300px]`} kattamInnerInjectclass={'h-[75px] w-[75px]'} readOnly={true} rasiValues={userDetails?.rasiKattam?.rasiPlanets} />
                <AmsaKattam kattamOuterInjectClass={`h-[300px] w-[300px]`} kattamInnerInjectclass={'h-[75px] w-[75px]'} readOnly={true} amsaValues={userDetails?.amsaKattam?.amsaPlanets} />
            </motion.div>}
            </motion.div>
        </motion.div>
    )
}

export default PrintUser